import { useState } from 'react'
import styled from 'styled-components'

import { TradesTable } from '@root/features/trade/tables/trades-table/ui/trades-table'
import { useTranslation } from '@root/shared/localization'
import { UnderlineTabs } from '@root/shared/ui-kit'

import { AnalyticsInfo } from './analytics-info'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type AnalyticsViewProps = {
  pair: PairModel | undefined
} & ClassNameProps

type AnalyticsTab = 'trades' | 'info'

export const AnalyticsView: React.FC<AnalyticsViewProps> = ({
  className,
  pair,
}) => {
  const { t } = useTranslation()
  const [tab, setTab] = useState<AnalyticsTab>('trades')

  if (!pair) {
    return undefined
  }

  return (
    <Root className={className}>
      <Header>
        <UnderlineTabs value={tab} onChange={setTab}>
          <UnderlineTabs.Tab value="trades">
            {t('analytics.tabs.trades')}
          </UnderlineTabs.Tab>
          <UnderlineTabs.Tab value="info">
            {t('analytics.tabs.info')}
          </UnderlineTabs.Tab>
        </UnderlineTabs>
      </Header>
      <Content>
        {tab === 'trades' && (
          <TradesTable pairAddress={pair.address} pair={pair} />
        )}
        {tab === 'info' && <AnalyticsInfo pair={pair} />}
      </Content>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const Content = styled.div``

const Header = styled.div`
  --tab-padding-inline: 8px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  background: var(--background-1);
  border-bottom: 1px solid var(--appearanceA-3);
  padding-inline: 12px;
`
